export const makeLocale = language => ({
  months: Array.from({
    length: 12
  }, (_, i) => new Date(Date.UTC(1970, i, 1)).toLocaleString(language, {
    month: 'long',
    timeZone: 'UTC'
  })),
  weekDays: Array.from({
    length: 7
  }, (_, i) => {
    const date = new Date(Date.UTC(1970, 0, i + 4));
    return {
      name: date.toLocaleString(language, {
        weekday: 'long',
        timeZone: 'UTC'
      }),
      short: date.toLocaleString(language, {
        weekday: 'short',
        timeZone: 'UTC'
      }),
      isWeekend: [0, 6].includes(i)
    };
  }),
  weekStartingIndex: 0,
  getToday(gregorianTodayObject) {
    return gregorianTodayObject;
  },
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },
  transformDigit(digit) {
    return digit;
  },
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: 'Select...',
  from: 'from',
  to: 'to',
  digitSeparator: ',',
  yearLetterSkip: 0,
  isRtl: false
});